import { render, staticRenderFns } from "./WorkDayModal.vue?vue&type=template&id=97a38404"
import script from "./WorkDayModal.vue?vue&type=script&lang=js"
export * from "./WorkDayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports